var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueOnline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 5.00016C1.3335 4.07969 2.07969 3.3335 3.00016 3.3335H8.00016C8.92064 3.3335 9.66683 4.07969 9.66683 5.00016V11.6668C9.66683 12.5873 8.92064 13.3335 8.00016 13.3335H3.00016C2.07969 13.3335 1.3335 12.5873 1.3335 11.6668V5.00016Z",
    fill: "#285E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7942 5.92147C11.5118 6.06263 11.3335 6.35119 11.3335 6.66683V10.0002C11.3335 10.3158 11.5118 10.6044 11.7942 10.7455L13.4608 11.5789C13.7191 11.708 14.0259 11.6942 14.2716 11.5424C14.5173 11.3905 14.6668 11.1223 14.6668 10.8335V5.8335C14.6668 5.54468 14.5173 5.27646 14.2716 5.12462C14.0259 4.97278 13.7191 4.95898 13.4608 5.08814L11.7942 5.92147Z",
    fill: "#285E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueOnline);
export default __webpack_public_path__ + "static/media/blue-online.d09d6cae42581c2369c0253dd5614ea4.svg";
export { ForwardRef as ReactComponent };